import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Mail } from "lucide-react";
import { decodeJwtPayload, generateOTP } from "../../services/authService";
import "./LoginPage.css";

const LoginPage = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const isValid = Boolean(email.trim());

  const handleSignInWithOTP = async () => {
    if (!isValid) return;
    setError("");
    setLoading(true);
    try {
      const submittedEmail = email.trim();
      const data = await generateOTP(submittedEmail);
      const payload = decodeJwtPayload(data.token);
      const tokenName = typeof payload?.name === "string" ? payload.name.trim() : "";
      const tokenEmail = typeof payload?.email === "string" ? payload.email.trim() : "";

      navigate("/otp", {
        state: {
          name: tokenName,
          email: tokenEmail || submittedEmail,
          token: data.token,
        },
      });
    } catch (err) {
      setError(err.message || "Failed to send OTP. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter" && isValid && !loading) handleSignInWithOTP();
  };

  return (
    <div className="login-page">
      {/* Navbar */}
      <header className="login-navbar">
        <div className="login-navbar-inner">
          <div className="login-logo-container">
            <img src="/AT_FullLogo.png" alt="Alpha Torana" className="login-logo" />
          </div>
        </div>
      </header>

      {/* Main content */}
      <main className="login-main">
        <div className="login-card">
          {/* Title */}
          <h1 className="login-title">Sign in</h1>

          {/* Email field */}
          <div className="login-field">
            <label className="login-label">Email</label>
            <div className="login-input-wrapper">
              <Mail size={17} className="login-input-icon" />
              <input
                type="email"
                className="login-input"
                placeholder="Enter your email address"
                value={email}
                onChange={(e) => { setEmail(e.target.value); setError(""); }}
                onKeyDown={handleKeyDown}
                disabled={loading}
              />
            </div>
            <div className="login-input-underline" />
          </div>

          {/* Error message */}
          {error && <p className="login-error">{error}</p>}

          {/* Buttons */}
          <div className="login-buttons">
            <button
              className={`login-btn login-btn-filled${(!isValid || loading) ? " login-btn--disabled" : ""}`}
              onClick={handleSignInWithOTP}
              disabled={!isValid || loading}
            >
              {loading ? "Sending OTP…" : "Send OTP"}
            </button>
          </div>
        </div>
      </main>
    </div>
  );
};

export default LoginPage;
